import React, { useState, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { getSubscriptionOptionList } from "../../../../../AdminApi/commFunc";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";
import FilterIcon from "../../../../DefaultStyles/FilterIcon";
import Flex from "../../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import Search from "../../../../Filters/Search";
import CalendarModal from "../../../../Modal/CalendarModal";
import ToolTip from "../../../../Modal/ToolTip";
import { CalendarLine } from "../../../Party/ChatInfo/ChatSearch/RecentChat";
import { PartyInfoFilterContainer } from "../../../Party/PartyInfo/PartyInfoFilter";

interface TempAccountHistoryFilterProps {
  setSearchOption: Dispatch<SetStateAction<OptionType>>;
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  searchDisabled: boolean;
  setFilters: Dispatch<
    SetStateAction<{
      startdate: string;
      enddate: string;
      value: string;
      filterType: string;
    }>
  >;
}

export default function TempAccountHistoryFilter({
  setSearchOption,
  setSearchValue,
  searchDisabled,
  setFilters,
}: TempAccountHistoryFilterProps) {
  const [filterType, setFilterType] = useState({
    value: "",
    label: "선택",
  });
  const [filter, setFilter] = useState({
    value: "",
    label: "선택",
  });
  const [startDate, setStartDate] = useState("날짜 선택");
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState("날짜 선택");
  const [endDateClick, setEndDateClick] = useState(false);

  const searchOptionList = [
    {
      value: "partyid",
      label: "PID",
    },
    {
      value: "uid",
      label: "UID",
    },
  ];

  const filterOption = [
    { value: "servsubsid", label: "Subscription" },
    { value: "isFail", label: "발급 상태" },
  ];

  const subsOptionList = getSubscriptionOptionList();

  const resultOptionList = [
    { value: "0", label: "성공" },
    { value: "1", label: "실패" },
  ];

  return (
    <FilterContainer>
      {/* 검색어 */}
      <div>
        <Flex gapSize={10}>
          <DropDown
            boxWidth={180}
            optionList={searchOptionList}
            setDropDownValue={setSearchOption}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            isDisabled={searchDisabled}
          />
        </Flex>
      </div>

      <div>
        {/* 필터 */}
        <FilterFlex gapSize={10}>
          <FilterIcon />

          <DropDown
            boxWidth={160}
            optionList={filterOption}
            dropdownValue={filterType}
            setDropDownValue={setFilterType}
          />

          <DropDown
            boxWidth={200}
            isDisabled={filterType?.value === ""}
            optionList={
              filterType?.value === "servsubsid"
                ? subsOptionList
                : resultOptionList
            }
            dropdownValue={filter}
            setDropDownValue={setFilter}
          />

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={filter?.value === ""}
            btnClickEvent={() =>
              setFilters((prev) => ({
                ...prev,
                value: filter?.value,
                filterType: filterType?.value,
              }))
            }
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={filter?.value === ""}
            btnClickEvent={() => {
              setFilterType({
                value: "",
                label: "선택",
              });
              setFilter({
                value: "",
                label: "선택",
              });
              setFilters((prev) => ({
                ...prev,
                value: "",
                filterType: "",
              }));
            }}
          />
        </FilterFlex>

        {/* 날짜 선택 */}
        <FilterFlex gapSize={10} style={{ marginBottom: 0 }}>
          <ToolTip
            direction="top"
            msg="한번에 최대 7일까지 조회 가능"
            noMsg={true}
          />

          <LineBoxContainer>
            <CalendarLineBtn
              onClickEvent={() => setStartDateClick(true)}
              value={startDate}
              initValue={"날짜 선택"}
              minWidth={155}
            />

            {startDateClick && (
              <CalendarModal
                closeEvent={() => setStartDateClick(false)}
                changeEvent={(date: string) => setStartDate(date)}
                isFutureDisable={true}
              />
            )}
          </LineBoxContainer>

          <CalendarLine />

          <LineBoxContainer>
            <CalendarLineBtn
              onClickEvent={() => setEndDateClick(true)}
              value={endDate}
              initValue={"날짜 선택"}
              minWidth={155}
              disabled={startDate === "날짜 선택"}
            />

            {endDateClick && (
              <CalendarModal
                closeEvent={() => setEndDateClick(false)}
                changeEvent={(date: string) => setEndDate(date)}
                dateValue={startDate}
                isAfter={{
                  value: 7,
                  unit: "day",
                }}
              />
            )}
          </LineBoxContainer>

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={endDate === "날짜 선택"}
            btnClickEvent={() => {
              setFilters((prev) => ({
                ...prev,
                startdate: startDate,
                enddate: endDate,
              }));
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={endDate === "날짜 선택"}
            btnClickEvent={() => {
              setStartDate("날짜 선택");
              setEndDate("날짜 선택");
              setFilters((prev) => ({
                ...prev,
                startdate: "",
                enddate: "",
              }));
            }}
          />
        </FilterFlex>
      </div>
    </FilterContainer>
  );
}

export const FilterContainer = styled(PartyInfoFilterContainer)`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;

  @media screen and (max-width: ${({ maxWidth }) => maxWidth ?? 1400}px) {
    flex-direction: column;
    align-items: flex-start !important;
  }
`;

export const FilterFlex = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: ${({ gapSize }) => `${gapSize ?? 0}px` ?? "unset"};
  gap: ${({ gapSize }) => `${gapSize ?? 0}px` ?? "unset"};
  margin-bottom: 10px;

  @media screen and (max-width: ${({ maxWidth }) => maxWidth ?? 1400}px) {
    justify-content: flex-start;
  }
`;
